import { render } from "./UserForm.vue?vue&type=template&id=f49a6ef6"
import script from "./UserForm.vue?vue&type=script&lang=js"
export * from "./UserForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__